import {
  Divider,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Input
} from '@material-ui/core'
import Dayjs from 'dayjs'
import { isNil, get } from 'lodash'
import React from 'react'

import { levelMap } from 'app/pages/Class/Inventory/constants'
import { composeBatchDetails } from 'app/pages/Class/Inventory/transformers'
import CoinIcon from 'assets/images/coin.png'

import { EnrolmentTypeSelection } from './components/EnrolmentTypeSelection'
import * as Styles from './styles'

import { fetchExcelScheduledEvents } from '../../../helpers'
import { SchedulesDate } from '../../../SchedulesDate'

const CourseDetail = ({
  allowStartDateDuringConflict = false,
  selectedItem,
  batchInfo,
  onBatchInfoChange,
  selectedBatchType,
  errorSchema,
  courseFormDisabled,
  isEditing,
  editingItem,
  enableDiscovery,
  discoveryEndDate,
  resubscribeStartDate
}) => {
  // The backend's enable_discovery is the value the dropdown should *default
  // to*, not a hard lock (see should_enable_discovery's docstring). Only lock
  // the field when discovery is genuinely not applicable (false) — e.g. the
  // student is already subscribed, resubscribing, or mid-discovery. When the
  // backend offers discovery (true) or defers to the operator (null), keep it
  // editable so the admin can override the default.
  const discoveryLocked = enableDiscovery === false
  let batchDetails = {}
  let existingBatchInfo = {}

  if (isEditing) {
    batchDetails = composeBatchDetails(editingItem.batchDetails)
    existingBatchInfo = editingItem.batchFormInfo
  } else {
    try {
      batchDetails = composeBatchDetails(selectedItem)
    } catch (error) {
      console.error('Error in composeBatchDetails:', error)
    }
  }

  const {
    uuid = '',
    subject = {},
    subjectsName = '',
    level = '',
    teacherName = '',
    coins_monthly = 0
  } = batchDetails

  const currentBatchInfo = isEditing
    ? existingBatchInfo
    : get(batchInfo, uuid, {})
  console.log(currentBatchInfo)
  const _endDate = get(currentBatchInfo, 'endDate', '')
  const endDateValue = _endDate?.value
  const endDateLabel = _endDate?.label
  const endDate = React.useMemo(() => {
    return (
      <FormControl variant="outlined" disabled={true} size="small">
        <InputLabel id="end-date-label">End Date</InputLabel>
        <Select
          labelId="end-date-label"
          value={endDateValue || ''}
          label="End Date"
          disabled={true}
          renderValue={() => endDateLabel}></Select>
      </FormControl>
    )
  }, [endDateLabel, endDateValue])

  return (
    <Styles.FormContainer>
      <Styles.Container>
        <Styles.TopContainer>
          <Styles.LeftContainer>
            {subject?.image && (
              <Styles.ImageContainer>
                <Styles.Image src={subject.image} />
              </Styles.ImageContainer>
            )}
            <Styles.DescriptionContainer>
              {subjectsName && <Styles.Title>{subjectsName}</Styles.Title>}
              {level && (
                <Styles.SubTitle>{levelMap[level] || level}</Styles.SubTitle>
              )}
              {teacherName && <Styles.SubTitle>{teacherName}</Styles.SubTitle>}
            </Styles.DescriptionContainer>
          </Styles.LeftContainer>
          <Styles.RightContainer>
            {currentBatchInfo?.price ? (
              <Styles.PriceContainer>
                <Styles.Icon src={CoinIcon} alt="coin image" />
                <Styles.PriceText>{currentBatchInfo?.price}</Styles.PriceText>
              </Styles.PriceContainer>
            ) : null}
          </Styles.RightContainer>
        </Styles.TopContainer>
        <Divider style={{ margin: '1em 0' }} />
        <Styles.BottomContainer>
          <Styles.OtherDetailsContainer>
            {subject?.discovery_enabled && (
              <EnrolmentTypeSelection
                handleOnChange={onBatchInfoChange}
                batchId={uuid}
                defaultValue={get(currentBatchInfo, 'isDiscover', '')}
                value={get(currentBatchInfo, 'isDiscover', '')}
                errorSchema={errorSchema}
                disabled={courseFormDisabled || discoveryLocked}
              />
            )}
            <SchedulesDate
              batchId={uuid}
              value={get(currentBatchInfo, 'startDate')}
              handleOnChange={onBatchInfoChange}
              propertyChange={'startDate'}
              selectedBatchType={selectedBatchType}
              placeholder={'Start Date'}
              scheduleFunction={fetchExcelScheduledEvents}
              batchInfo={currentBatchInfo}
              // On a class conflict this stays OPEN. The conflict is judged as
              // of the start date, so the operator has to be able to set one for
              // the re-check to happen at all.
              //
              // The second lock is the `isDiscover` one: a conflict response
              // carries `enable_discovery: null`, which lands here as nil and
              // would keep the field dead on its own. Both have to give way
              // together or the fix is invisible.
              disabled={
                allowStartDateDuringConflict
                  ? false
                  : isNil(get(currentBatchInfo, 'isDiscover')) ||
                    courseFormDisabled
              }
              discoveryEndDate={discoveryEndDate}
              resubscribeStartDate={resubscribeStartDate}
            />
            {get(currentBatchInfo, 'isDiscover') && endDate}
          </Styles.OtherDetailsContainer>
        </Styles.BottomContainer>
      </Styles.Container>
    </Styles.FormContainer>
  )
}

export { CourseDetail }
